(function (root) {
  var PROPERTY_KEY = "_apa_checkout_session";
  var MINIMUM_CENTS = 5000;
  var MEMBERSHIP_HANDLE = "association-membership";
  var SUPPORT_HANDLE = "apa-support-contribution";
  var PREPARATION_PATH = "/apps/pma-saved-products/checkout-preparation";
  var DEBOUNCE_MS = 400;

  function text(value) {
    return String(value == null ? "" : value).trim();
  }

  function propertyValue(item, key) {
    var props = item && item.properties;
    if (!props) return "";
    if (Object.prototype.toString.call(props) === "[object Array]") {
      for (var index = 0; index < props.length; index += 1) {
        var name = text(props[index] && (props[index].name || props[index].key));
        if (name === key) return text(props[index].value);
      }
      return "";
    }
    return text(props[key]);
  }

  function recordedRole(item, options) {
    var catalog = (options && options.catalog) || {};
    var byVariant = catalog.by_variant_id || {};
    var byProduct = catalog.by_product_id || {};
    var byHandle = catalog.by_handle || {};
    return byVariant[text(item && item.variant_id)]
      || byProduct[text(item && item.product_id)]
      || byHandle[text(item && (item.handle || item.product_handle))]
      || "";
  }

  function lineRole(item, options) {
    var recorded = recordedRole(item, options);
    if (recorded === "support" || recorded === "membership" || recorded === "merchandise") return recorded;
    var handle = text(item && (item.handle || item.product_handle));
    var type = text(item && (item.product_type || item.productType)).toLowerCase();
    var title = text(item && (item.title || item.product_title)).toLowerCase();
    var tags = item && Array.isArray(item.tags) ? item.tags.join(",") : text(item && item.tags);
    var tagText = tags.toLowerCase();
    var revenue = text((item && item.revenue_class) || propertyValue(item, "_pma_revenue_class")).toLowerCase();
    var membershipHandle = (options && options.membershipHandle) || MEMBERSHIP_HANDLE;
    var supportHandle = (options && options.supportHandle) || SUPPORT_HANDLE;
    if (
      handle === supportHandle
      || handle === SUPPORT_HANDLE
      || revenue === "support"
      || tagText.indexOf("apa-support") >= 0
      || tagText.indexOf("support-contribution") >= 0
      || tagText.indexOf("pma_support_contribution") >= 0
      || type.indexOf("support contribution") >= 0
      || title.indexOf("support contribution") >= 0
      || title.indexOf("support apa") >= 0
    ) return "support";
    if (
      handle === membershipHandle
      || type === "membership"
      || tagText.indexOf("pma_membership") >= 0
      || title.indexOf("membership") >= 0
    ) return "membership";
    return "merchandise";
  }

  function decideMinimumOrder(cart, options) {
    var cents = 0;
    var hasMerchandise = false;
    var items = (cart && cart.items) || [];
    for (var index = 0; index < items.length; index += 1) {
      if (lineRole(items[index], options) !== "merchandise") continue;
      hasMerchandise = true;
      var price = items[index].final_line_price;
      if (price == null || price === "" || !isFinite(Number(price)) || Number(price) < 0) {
        return { blocked: true, reason: "minimum_order_unpriced", merchandiseCents: null };
      }
      cents += Number(price);
    }
    if (!hasMerchandise || !(cents > 0) || cents >= MINIMUM_CENTS) {
      return { blocked: false, merchandiseCents: cents };
    }
    return { blocked: true, reason: "below_minimum_order", merchandiseCents: cents };
  }

  function isGovernedCartMutation(url) {
    var path = String(url || "");
    if (path.indexOf(PREPARATION_PATH) >= 0 || path.indexOf("/cart.js") >= 0) return false;
    return /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(path);
  }

  function sessionValue(item) {
    var props = item && item.properties;
    if (!props) return "";
    if (Object.prototype.toString.call(props) === "[object Array]") {
      for (var index = 0; index < props.length; index += 1) {
        var name = text(props[index] && (props[index].name || props[index].key));
        if (name === PROPERTY_KEY) return text(props[index].value);
      }
      return "";
    }
    return text(props[PROPERTY_KEY]);
  }

  function checkoutSessionState(cart, options) {
    var items = (cart && cart.items) || [];
    var tokens = [];
    for (var index = 0; index < items.length; index += 1) {
      var item = items[index];
      if (item.requires_shipping === false) continue;
      if (lineRole(item, options) !== "merchandise") continue;
      tokens.push(sessionValue(item));
    }
    if (!tokens.length) return { ok: true, required: false, token: null };
    for (var tokenIndex = 0; tokenIndex < tokens.length; tokenIndex += 1) {
      if (!tokens[tokenIndex]) return { ok: false, reason: "missing_checkout_session" };
    }
    var first = tokens[0];
    for (var compare = 1; compare < tokens.length; compare += 1) {
      if (tokens[compare] !== first) return { ok: false, reason: "checkout_session_conflict" };
    }
    return { ok: true, required: true, token: first };
  }

  function cartIdentity(cart) {
    return ((cart && cart.items) || []).map(function (item) {
      return [
        text(item.variant_id),
        Number(item.quantity),
        Number(item.final_line_price || 0),
        text(item.sku),
        sessionValue(item),
      ].join("|");
    }).join("\n");
  }

  function cartChanged(before, after) {
    return cartIdentity(before) !== cartIdentity(after);
  }

  function checkoutGate(cart, options) {
    var items = (cart && cart.items) || [];
    var hasMerchandise = false;
    for (var index = 0; index < items.length; index += 1) {
      if (lineRole(items[index], options) === "merchandise") hasMerchandise = true;
    }
    if (!hasMerchandise) return { action: "proceed_without_packing" };
    var minimum = decideMinimumOrder(cart, options);
    if (minimum.blocked) return { action: "block_minimum", reason: minimum.reason, merchandiseCents: minimum.merchandiseCents };
    var session = checkoutSessionState(cart, options);
    if (!session.ok) return { action: "block_session", reason: session.reason };
    return { action: "prepare", token: session.token };
  }

  function createPreparationScheduler(prepare, waitMs) {
    var timer = null;
    var generation = 0;
    return {
      schedule: function (cart) {
        var current = ++generation;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          if (current === generation) prepare(cart);
        }, waitMs == null ? DEBOUNCE_MS : waitMs);
      },
      cancel: function () {
        generation += 1;
        if (timer) clearTimeout(timer);
        timer = null;
      },
    };
  }

  function createCheckoutFlight() {
    var active = false;
    return {
      begin: function () {
        if (active) return false;
        active = true;
        return true;
      },
      release: function () {
        active = false;
      },
      active: function () {
        return active;
      },
    };
  }

  function claimCheckout(deps) {
    if (!deps.flight) return { owned: false, blocked: false };
    if (!deps.flight.begin()) return { owned: false, blocked: true };
    if (typeof deps.onBusy === "function") deps.onBusy();
    return { owned: true, blocked: false };
  }

  function finishCheckout(claim, deps, result) {
    if (claim && claim.owned && (!result || !result.navigated)) {
      deps.flight.release();
      if (typeof deps.onIdle === "function") deps.onIdle();
    }
    return result;
  }

  async function governedCheckout(deps) {
    var claim = claimCheckout(deps);
    if (claim.blocked) return { navigated: false, action: "checkout_in_flight" };
    try {
      var fetchImpl = deps.fetchImpl;
      var cart = deps.cart;
      if (!cart) cart = await (await fetchImpl("/cart.js", { cache: "no-store" })).json();
      var gate = checkoutGate(cart, deps.options);
      if (gate.action === "block_minimum" || gate.action === "block_session") {
        return finishCheckout(claim, deps, {
          navigated: false,
          action: gate.action,
          reason: gate.reason,
          merchandiseCents: gate.merchandiseCents,
          cart: cart,
        });
      }
      if (gate.action === "proceed_without_packing") {
        if (deps.navigate) deps.navigate("/checkout");
        return { navigated: true, action: gate.action, cart: cart };
      }
      var prepared = await deps.prepare(cart);
      if (!prepared || prepared.status !== "READY") {
        return finishCheckout(claim, deps, {
          navigated: false,
          action: "block_preparation",
          reason: prepared && prepared.failure_reason,
          cart: cart,
        });
      }
      var freshResponse = await fetchImpl("/cart.js", { cache: "no-store" });
      var fresh = await freshResponse.json();
      if (cartChanged(cart, fresh)) {
        return finishCheckout(claim, deps, { navigated: false, action: "block_cart_changed", cart: fresh });
      }
      var freshGate = checkoutGate(fresh, deps.options);
      if (freshGate.action !== "prepare") {
        return finishCheckout(claim, deps, { navigated: false, action: freshGate.action, reason: freshGate.reason, cart: fresh });
      }
      if (deps.navigate) deps.navigate(deps.checkoutPath || "/checkout");
      return { navigated: true, action: "checkout", cart: fresh };
    } catch (error) {
      finishCheckout(claim, deps, { navigated: false });
      throw error;
    }
  }

  function afterAcceptedAdd(claim, deps, reason) {
    return finishCheckout(claim, deps, {
      navigated: false,
      action: "block_checkout_after_add",
      added: true,
      reason: reason,
    });
  }

  async function buyNow(form, deps) {
    var claim = claimCheckout(deps);
    if (claim.blocked) return { navigated: false, action: "checkout_in_flight" };
    var addAccepted = false;
    try {
      var state = await deps.sessionApi.whenReady();
      if (!state || !state.ready || !state.token) {
        return finishCheckout(claim, deps, { navigated: false, action: "block_session", reason: "missing_checkout_session", added: false });
      }
      var body = new deps.FormData(form);
      body.delete("return_to");
      body.set("properties[" + PROPERTY_KEY + "]", state.token);
      var addedResponse;
      try {
        addedResponse = await deps.fetchImpl(form.getAttribute ? (form.getAttribute("action") || "/cart/add.js") : "/cart/add.js", {
          method: "POST",
          body: body,
        });
      } catch (error) {
        return finishCheckout(claim, deps, { navigated: false, action: "block_add_unknown", added: false, reason: "add_outcome_unknown" });
      }
      if (!addedResponse || addedResponse.ok !== true) {
        if (addedResponse && addedResponse.ok === false) {
          return finishCheckout(claim, deps, { navigated: false, action: "block_add", added: false });
        }
        return finishCheckout(claim, deps, { navigated: false, action: "block_add_unknown", added: false, reason: "add_outcome_unknown" });
      }
      addAccepted = true;
      if (deps.sessionApi.syncCartLineSessions) await deps.sessionApi.syncCartLineSessions();
      var cart;
      try {
        var cartResponse = await deps.fetchImpl("/cart.js", { cache: "no-store" });
        if (!cartResponse || cartResponse.ok === false || typeof cartResponse.json !== "function") {
          return afterAcceptedAdd(claim, deps, "cart_read_failed");
        }
        cart = await cartResponse.json();
      } catch (error) {
        return afterAcceptedAdd(claim, deps, "cart_read_failed");
      }
      var result = await governedCheckout({
        cart: cart,
        fetchImpl: deps.fetchImpl,
        prepare: deps.prepare,
        navigate: deps.navigate,
        options: deps.options,
      });
      return finishCheckout(claim, deps, Object.assign({}, result, { added: true }));
    } catch (error) {
      if (addAccepted) return afterAcceptedAdd(claim, deps, "checkout_continued_failed");
      finishCheckout(claim, deps, { navigated: false });
      throw error;
    }
  }

  function preparationPayload(cart, options) {
    return {
      currency: (cart && cart.currency) || "USD",
      items: ((cart && cart.items) || []).filter(function (item) {
        return item.requires_shipping !== false && lineRole(item, options) === "merchandise";
      }).map(function (item) {
        return {
          sku: item.sku,
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
          grams: item.grams,
          price: item.price,
          name: item.product_title || item.title,
          vendor: item.vendor,
          properties: item.properties,
          requires_shipping: true,
        };
      }),
    };
  }

  var PREPARING_LABEL = "Preparing shipping packages…";

  function buttonLabel(button) {
    if (!button || typeof button.querySelector !== "function") return null;
    return button.querySelector(".pma-btn__label");
  }

  function setCheckoutButtonBusy(button) {
    if (!button || (typeof button.getAttribute === "function" && button.getAttribute("data-pma-preparation-busy") === "true")) return;
    if (typeof button.setAttribute === "function") {
      button.setAttribute("data-pma-preparation-busy", "true");
      button.setAttribute("aria-busy", "true");
      button.setAttribute("aria-disabled", "true");
    }
    if (button.classList) button.classList.add("is-preparing");
    var label = buttonLabel(button);
    if (label) {
      button.__pmaPreparationLabel = label.textContent;
      label.textContent = PREPARING_LABEL;
    }
    if (typeof button.querySelector === "function" && button.querySelector(".pma-btn__spinner")) return;
    var doc = button.ownerDocument;
    if (!doc || typeof doc.createElement !== "function" || typeof button.insertBefore !== "function") return;
    var spinner = doc.createElement("span");
    spinner.className = "pma-btn__spinner";
    if (typeof spinner.setAttribute === "function") spinner.setAttribute("aria-hidden", "true");
    button.insertBefore(spinner, button.firstChild || null);
  }

  function restoreCheckoutButton(button) {
    if (!button) return;
    if (button.classList) button.classList.remove("is-preparing");
    if (typeof button.setAttribute === "function") button.setAttribute("aria-busy", "false");
    if (typeof button.removeAttribute === "function") {
      button.removeAttribute("aria-disabled");
      button.removeAttribute("data-pma-preparation-busy");
    }
    var label = buttonLabel(button);
    if (label && button.__pmaPreparationLabel != null) label.textContent = button.__pmaPreparationLabel;
    button.__pmaPreparationLabel = null;
    var spinner = typeof button.querySelector === "function" ? button.querySelector(".pma-btn__spinner") : null;
    if (spinner && spinner.parentNode && typeof spinner.parentNode.removeChild === "function") {
      spinner.parentNode.removeChild(spinner);
    }
  }

  function submitPreparedCheckout(form, button) {
    if (!form || typeof form.setAttribute !== "function") return;
    form.setAttribute("data-pma-preparation-allow", "1");
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit(button || undefined);
      return;
    }
    var doc = root.document;
    if (button && typeof button.getAttribute === "function" && button.getAttribute("name") && doc && typeof form.querySelector === "function" && !form.querySelector("[name='" + button.getAttribute("name") + "']")) {
      var input = doc.createElement("input");
      input.type = "hidden";
      input.name = button.getAttribute("name");
      input.value = button.getAttribute("value") || "";
      form.appendChild(input);
    }
    if (typeof form.submit === "function") form.submit();
  }

  function dollars(cents) {
    var amount = Math.max(0, Math.round(Number(cents) || 0));
    return "$" + (amount / 100).toFixed(2);
  }

  function checkoutNoticeFor(result) {
    if (!result || result.navigated || result.action === "checkout_in_flight" || result.action === "proceed_without_packing") {
      return null;
    }
    if (result.action === "block_minimum") {
      if (result.reason === "minimum_order_unpriced") {
        return {
          tone: result.added ? "status" : "alert",
          title: result.added ? "Added to your cart" : "Checkout needs $50 of merchandise",
          body: "This cart could not be priced. Review it before checkout.",
          actionHref: "/cart",
          actionLabel: "Review cart",
        };
      }
      var remaining = Math.max(0, MINIMUM_CENTS - Number(result.merchandiseCents || 0));
      return {
        tone: result.added ? "status" : "alert",
        title: result.added ? "Added to your cart" : "Checkout needs $50 of merchandise",
        body: "Add " + dollars(remaining) + " more merchandise before checkout.",
        actionHref: "/cart",
        actionLabel: "Review cart",
      };
    }
    if (result.action === "block_session") {
      if (result.added) {
        return {
          tone: "status",
          title: "Added to your cart",
          body: "Checkout could not continue. Please retry.",
          actionHref: "/cart",
          actionLabel: "Review cart",
        };
      }
      return {
        tone: "alert",
        title: "Cart not updated",
        body: "Your cart could not be updated. Please retry.",
      };
    }
    if (result.action === "block_add_unknown") {
      return {
        tone: "alert",
        title: "Cart update uncertain",
        body: "We could not confirm whether this item was added. Review your cart before trying again.",
        actionHref: "/cart",
        actionLabel: "Review cart",
      };
    }
    if (result.action === "block_add") {
      return {
        tone: "alert",
        title: "Not added",
        body: "This item was not added to your cart. Please retry.",
      };
    }
    if (result.action === "block_cart_changed") {
      return {
        tone: result.added ? "status" : "alert",
        title: result.added ? "Added to your cart" : "Cart changed",
        body: result.added
          ? "Your cart changed before checkout. Review it before continuing."
          : "Your cart changed. Review it before checkout.",
        actionHref: "/cart",
        actionLabel: "Review cart",
      };
    }
    if (result.added) {
      return {
        tone: "alert",
        title: "Added to your cart",
        body: "Checkout could not continue. Please retry.",
        actionHref: "/cart",
        actionLabel: "Review cart",
      };
    }
    return {
      tone: "alert",
      title: "Checkout could not continue",
      body: "Shipping packages could not be prepared. Please retry.",
    };
  }

  function showNotice(notice) {
    var doc = root.document;
    if (!notice || !doc || typeof doc.createElement !== "function" || !doc.body) return null;
    var region = typeof doc.querySelector === "function"
      ? doc.querySelector(".pma-toast-region[data-pma-checkout-notices]")
      : null;
    if (!region) {
      region = doc.createElement("div");
      region.className = "pma-toast-region";
      if (typeof region.setAttribute === "function") region.setAttribute("data-pma-checkout-notices", "true");
      doc.body.appendChild(region);
    }
    if (typeof region.replaceChildren === "function") region.replaceChildren();
    else region.textContent = "";
    var toast = doc.createElement("div");
    toast.className = "pma-toast";
    if (notice.tone === "alert") {
      toast.setAttribute("role", "alert");
    } else {
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
    }
    var copy = doc.createElement("div");
    var title = doc.createElement("p");
    title.className = "pma-toast__title";
    title.textContent = notice.title || "";
    var body = doc.createElement("p");
    body.className = "pma-toast__body";
    body.textContent = notice.body || "";
    if (notice.actionHref && typeof doc.createElement === "function") {
      var link = doc.createElement("a");
      link.href = notice.actionHref;
      link.textContent = notice.actionLabel || "Review cart";
      if (typeof doc.createTextNode === "function") body.appendChild(doc.createTextNode(" "));
      if (typeof body.appendChild === "function") body.appendChild(link);
    }
    copy.appendChild(title);
    copy.appendChild(body);
    var close = doc.createElement("button");
    close.type = "button";
    close.className = "pma-toast__close";
    if (typeof close.setAttribute === "function") close.setAttribute("aria-label", "Dismiss notification");
    close.textContent = "Close";
    if (typeof close.addEventListener === "function") {
      close.addEventListener("click", function () {
        if (typeof region.replaceChildren === "function") region.replaceChildren();
        else region.textContent = "";
      });
    }
    toast.appendChild(copy);
    toast.appendChild(close);
    region.appendChild(toast);
    return toast;
  }

  var api = {
    PROPERTY_KEY: PROPERTY_KEY,
    MINIMUM_CENTS: MINIMUM_CENTS,
    PREPARATION_PATH: PREPARATION_PATH,
    lineRole: lineRole,
    decideMinimumOrder: decideMinimumOrder,
    isGovernedCartMutation: isGovernedCartMutation,
    checkoutSessionState: checkoutSessionState,
    cartChanged: cartChanged,
    checkoutGate: checkoutGate,
    createPreparationScheduler: createPreparationScheduler,
    createCheckoutFlight: createCheckoutFlight,
    governedCheckout: governedCheckout,
    buyNow: buyNow,
    preparationPayload: preparationPayload,
    setCheckoutButtonBusy: setCheckoutButtonBusy,
    restoreCheckoutButton: restoreCheckoutButton,
    submitPreparedCheckout: submitPreparedCheckout,
    checkoutNoticeFor: checkoutNoticeFor,
    showNotice: showNotice,
  };
  root.pmaCheckoutPreparation = api;

  if (!root.document || typeof root.document.addEventListener !== "function") return;

  function status(message) {
    if (!message) {
      var region = root.document && root.document.querySelector
        ? root.document.querySelector(".pma-toast-region[data-pma-checkout-notices]")
        : null;
      if (region && typeof region.replaceChildren === "function") region.replaceChildren();
      return;
    }
    var preparing = message === PREPARING_LABEL;
    showNotice({
      tone: preparing ? "status" : "alert",
      title: preparing ? "Preparing checkout" : "Checkout could not continue",
      body: message,
    });
  }

  function readDomCatalog() {
    var catalog = { by_variant_id: {}, by_product_id: {}, by_handle: {} };
    if (!root.document || !root.document.querySelectorAll) return catalog;
    var nodes = root.document.querySelectorAll("[data-pma-minimum-role]");
    for (var index = 0; index < nodes.length; index += 1) {
      var node = nodes[index];
      var role = text(node.getAttribute("data-pma-minimum-role"));
      if (role !== "support" && role !== "membership" && role !== "merchandise") continue;
      var variantId = text(node.getAttribute("data-pma-variant-id"));
      var productId = text(node.getAttribute("data-pma-product-id"));
      var handle = text(node.getAttribute("data-pma-product-handle"));
      if (variantId) catalog.by_variant_id[variantId] = role;
      if (productId) catalog.by_product_id[productId] = role;
      if (handle) catalog.by_handle[handle] = role;
    }
    return catalog;
  }

  function nativeFetch() {
    return root.__apaCheckoutSessionNativeFetch || root.fetch.bind(root);
  }

  function installCartMutationSchedule() {
    if (root.__apaCheckoutPreparationFetchPatched || typeof root.fetch !== "function") return;
    root.__apaCheckoutPreparationFetchPatched = true;
    var current = root.fetch.bind(root);
    root.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var options = init || {};
      var run = current(input, options);
      if (!isGovernedCartMutation(url)) return run;
      return run.then(function (response) {
        if (response && response.ok && !checkoutFlight.active()) {
          scheduler.schedule({ refresh: true });
        }
        return response;
      });
    };
  }

  async function prepareCart(cart) {
    var payload = preparationPayload(cart, { catalog: readDomCatalog() });
    if (!payload.items.length) return { status: "READY", groups: [] };
    status("Preparing shipping packages…");
    var response = await nativeFetch()(PREPARATION_PATH, {
      method: "POST",
      headers: { accept: "application/json", "content-type": "application/json" },
      body: JSON.stringify(payload),
    });
    var body = null;
    try { body = await response.json(); } catch (error) { body = null; }
    if (!response.ok || !body || body.status !== "READY") {
      status("Shipping packages could not be prepared. Retry checkout.");
      return body || { status: "FAILED", failure_reason: "preparation_request_failed" };
    }
    if (!checkoutFlight.active()) status("");
    return body;
  }

  var checkoutFlight = createCheckoutFlight();

  function markCheckoutBusy(button) {
    status(PREPARING_LABEL);
    setCheckoutButtonBusy(button);
  }

  function markCheckoutIdle(button) {
    restoreCheckoutButton(button);
  }

  function reportCheckout(result) {
    if (!result || result.action === "checkout_in_flight" || result.navigated) return result;
    var notice = checkoutNoticeFor(result);
    if (notice) showNotice(notice);
    if (result.action === "block_cart_changed") scheduler.schedule(result.cart || { refresh: true });
    return result;
  }

  function startCheckout(task, button) {
    return Promise.resolve(task({
      flight: checkoutFlight,
      onBusy: function () { markCheckoutBusy(button); },
      onIdle: function () { markCheckoutIdle(button); },
      fetchImpl: nativeFetch(),
      prepare: prepareCart,
      options: { catalog: readDomCatalog() },
    })).then(reportCheckout, function (error) {
      checkoutFlight.release();
      markCheckoutIdle(button);
      status("Shipping packages could not be prepared. Retry checkout.");
      throw error;
    });
  }

  var scheduler = createPreparationScheduler(function () {
    nativeFetch()("/cart.js", { cache: "no-store", credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var gate = checkoutGate(cart, { catalog: readDomCatalog() });
        if (gate.action === "prepare" || (cart.items || []).some(function (item) {
          return item.requires_shipping !== false && lineRole(item, { catalog: readDomCatalog() }) === "merchandise";
        })) {
          return prepareCart(cart);
        }
        return null;
      })
      .catch(function () { status("Shipping packages could not be prepared. Retry checkout."); });
  }, DEBOUNCE_MS);
  installCartMutationSchedule();

  function navigateCheckout() {
    root.location.assign("/checkout");
  }

  root.document.addEventListener("keydown", function (event) {
    if (!event || event.key !== "Escape") return;
    var region = root.document.querySelector(".pma-toast-region[data-pma-checkout-notices]");
    if (!region) return;
    if (typeof region.replaceChildren === "function") region.replaceChildren();
  });

  root.document.addEventListener("click", function (event) {
    var target = event.target && event.target.closest ? event.target.closest("[data-pma-cta]") : null;
    if (!target) return;
    var cta = target.getAttribute("data-pma-cta");
    if (target.getAttribute("data-pma-checkout-nojs") === "true") return;
    if (cta === "buy_now" || cta === "sticky_buy_now") {
      event.preventDefault();
      event.stopPropagation();
      var form = target.form || root.document.getElementById(target.getAttribute("form") || "");
      if (!form) return;
      var sessionApi = root.PMA && root.PMA.checkoutSession;
      if (!sessionApi) {
        status("Checkout session is not ready. Retry.");
        return;
      }
      scheduler.cancel();
      startCheckout(function (shared) {
        return buyNow(form, {
          flight: shared.flight,
          onBusy: shared.onBusy,
          onIdle: shared.onIdle,
          FormData: root.FormData,
          fetchImpl: shared.fetchImpl,
          sessionApi: sessionApi,
          prepare: shared.prepare,
          navigate: navigateCheckout,
          options: shared.options,
        });
      }, target);
    }
    if (cta === "checkout") {
      var checkoutForm = target.form;
      if (!checkoutForm) return;
      event.preventDefault();
      event.stopPropagation();
      scheduler.cancel();
      startCheckout(function (shared) {
        return governedCheckout({
          flight: shared.flight,
          onBusy: shared.onBusy,
          onIdle: shared.onIdle,
          fetchImpl: shared.fetchImpl,
          prepare: shared.prepare,
          options: shared.options,
          navigate: function () {
            submitPreparedCheckout(checkoutForm, target);
          },
        });
      }, target);
    }
  }, true);

  root.document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains("pma-cart-summary__checkout-form")) return;
    if (form.getAttribute("data-pma-preparation-allow") === "1") {
      form.setAttribute("data-pma-preparation-allow", "0");
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    var submitter = typeof form.querySelector === "function" ? form.querySelector('[name="checkout"]') : null;
    scheduler.cancel();
    startCheckout(function (shared) {
      return governedCheckout({
        flight: shared.flight,
        onBusy: shared.onBusy,
        onIdle: shared.onIdle,
        fetchImpl: shared.fetchImpl,
        prepare: shared.prepare,
        options: shared.options,
        navigate: function () {
          submitPreparedCheckout(form, submitter);
        },
      });
    }, submitter);
  }, true);

  root.document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches("[data-pma-cart-form]")) return;
    if (checkoutFlight.active()) return;
    scheduler.schedule({ refresh: true });
  }, true);

  if (root.document.readyState === "loading") {
    root.document.addEventListener("DOMContentLoaded", function () {
      nativeFetch()("/cart.js", { cache: "no-store" }).then(function (response) { return response.json(); }).then(function (cart) {
        var options = { catalog: readDomCatalog() };
        var needsPacking = (cart.items || []).some(function (item) {
          return item.requires_shipping !== false && lineRole(item, options) === "merchandise";
        });
        if (needsPacking) scheduler.schedule(cart);
      }).catch(function () {});
    });
  }
})(typeof window !== "undefined" ? window : globalThis);
